import { render } from "./InvoicesTable.vue?vue&type=template&id=f6bf9c7e&scoped=true"
import script from "./InvoicesTable.vue?vue&type=script&lang=js"
export * from "./InvoicesTable.vue?vue&type=script&lang=js"

import "./InvoicesTable.vue?vue&type=style&index=0&id=f6bf9c7e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6bf9c7e"]])

export default __exports__